import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetPatientInquiryListStatusEnum,
  PatientInquiryControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface UseListPatientInquiryProps {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  providerId?: string;
  status?: GetPatientInquiryListStatusEnum[];
  searchString?: string;
  source?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export const useListPatientInquiry = ({
  pagination,
  gridSorting,
  providerId,
  status,
  searchString,
  source,
  xTENANTID,
  enabled = true,
}: UseListPatientInquiryProps): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);
  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "collaboration-patient-inquiry-list",
      pageIndex,
      pagination.pageSize,
      sortData?.field,
      sortData?.sort,
      providerId,
      status,
      searchString,
      source,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
    queryFn: async () =>
      await new PatientInquiryControllerApi(getConfigObject())
        .getPatientInquiryList(
          pageIndex,
          pagination.pageSize,
          sortData?.field,
          sortData?.sort ?? undefined,
          providerId,
          status?.length ? status : undefined,
          searchString || undefined,
          source || undefined,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
